module.exports = __webpack_public_path__ + "media/images/common/btn01-697cd58e3b5130de3444e4b13d1757fd.gif";